
namespace GeniuzPOS.SalePromoCamp {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PsPromoActiveHdDialog extends Serenity.EntityDialog<PsPromoActiveHdRow, any> {
        protected getFormKey() { return PsPromoActiveHdForm.formKey; }
        protected getIdProperty() { return PsPromoActiveHdRow.idProperty; }
        protected getLocalTextPrefix() { return PsPromoActiveHdRow.localTextPrefix; }
        protected getNameProperty() { return PsPromoActiveHdRow.nameProperty; }
        protected getService() { return PsPromoActiveHdService.baseUrl; }
        protected getDeletePermission() { return PsPromoActiveHdRow.deletePermission; }
        protected getInsertPermission() { return PsPromoActiveHdRow.insertPermission; }
        protected getUpdatePermission() { return PsPromoActiveHdRow.updatePermission; }

        protected form = new PsPromoActiveHdForm(this.idPrefix);

        constructor() {
            super();


        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSaveApproveBtn: Serenity.ToolButton =
                {
                    title: "Active",
                    hint: "Approve and Save",
                    separator: false,
                    cssClass: "button-save-approve",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        // var plucode = Q.toId(this.form.PluCode.value)
                        // this.price1 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice1;
                        // this.price2 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice2;
                        // this.price3 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice3;
                        // this.price4 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice4;
                        // this.price5 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice5;
                        // this.price6 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice6;

                        Q.confirm(
                            // "ราคาเดิม (อ้างอิง ณ ปัจจุบัน) > ราคาที่กำหนดใหม่" + "\r\n" +
                            // this.price1 + " > " + this.form.SellUnitPrice1.value + "\r\n" +
                            // this.price2 + " > " + this.form.SellUnitPrice2.value + "\r\n" +
                            // this.price3 + " > " + this.form.SellUnitPrice3.value + "\r\n" +
                            // this.price4 + " > " + this.form.SellUnitPrice4.value + "\r\n" +
                            // this.price5 + " > " + this.form.SellUnitPrice5.value + "\r\n" +
                            // this.price6 + " > " + this.form.SellUnitPrice6.value + "\r\n" +
                            '  ยืนยันการเปิดใช้งาน โปรโมชั่น ',
                            () => {
                                this.form.PromoStatus.value = "1";
                                this.form.PromoStatus.forceUpdate();
                                this.save((response) => {
                                    this.dialogClose();
                                });
                            });
                    }
                };
                buttons.push(newSaveApproveBtn);
                // let newSaveRejectedBtn: Serenity.ToolButton =
                // {
                //     title: "ไม่อนุมัติ",
                //     hint: "Rejected and Save",
                //     separator: false,
                //     cssClass: "button-save-reject",
                //     icon: "fa fa-save",
                //     hotkey: 'alt+s',
                //     onClick: (e) => {
                //         Q.confirm(
                //             "ไม่อนุมัติรายการนี้ " + "\r\n" +
                //             ' ยืนยันการบันทึก',
                //             () => {
                //                 this.form.PromoStatus.value = 0;
                //                 this.form.PromoStatus.forceUpdate();
                //                 this.save((response) => {
                //                     this.dialogClose();
                //                 });
                //             });
                //     }
                // };
                // buttons.push(newSaveRejectedBtn);
            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );

            let newSaveRejectedBtn: Serenity.ToolButton =
            {
                title: "InActive",
                hint: "ยกเลิก Active",
                separator: false,
                cssClass: "button-save-cancle",
                icon: "fa fa-times-circle text-red",
                hotkey: 'alt+s',
                onClick: (e) => {
                    Q.confirm(
                        "ยกเลิกการเปิดใช้งานโปรโมชั่นนี้ "
                        ,
                        () => {
                            this.form.PromoStatus.value = "0";
                            this.form.PromoStatus.forceUpdate();
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });
                }
            }
            buttons.push(newSaveRejectedBtn);

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.syscuscheck();


            this.toolbar.findButton('delete-button').hide();
            this.toolbar.findButton('button-apply').hide();
            var date = $.datepicker.formatDate('yymmdd', new Date());
            var effdate = this.entity.EndPromoDate
            var a = effdate.split('T')[0];
            var effectdate = a.split('-')[0] + a.split('-')[1] + a.split('-')[2]
            //Q.confirm(effectdate + date, () => { });
            if (effectdate < date) {
            // if (this.entity.PromoApproveFg == 1) {
                this.toolbar.findButton('button-save-approve').hide();
                
                this.toolbar.findButton('button-save-cancle').hide();
            
            }else{
            // if (this.entity.PromoApproveFg == 1) {
                if (this.entity.PromoStatus == 1) {
                    this.toolbar.findButton('button-save-approve').hide();
                    // this.toolbar.findButton('button-save-cancle').hide();
                    // this.toolbar.findButton('button-save-reject').hide();
                } else {
                    // this.toolbar.findButton('button-save-approve').hide();
                    this.toolbar.findButton('button-save-cancle').hide();

                }
            }
            

        }

        private syscuscheck() {
            let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 14 && x.SysFg > 0)
            console.log(app)
            if (app != null) {
                this.form.VenderSharing.getGridField().toggle(true);
            } else {
                this.form.VenderSharing.getGridField().toggle(false);
            }

        }

    }
}